export const safeGetPortalId = (): string | null =>
  (window && (window as any)?.hubspot?.portal?.id?.toString()) || null;
